import { MutationTree } from 'vuex';
import { IDocument } from '@/types/Document';
import { ITemplateLibraryState } from '@/dealroom/template-library/store/template-library.store';
import { IFolder } from '@/folders/types/folder';
import { IFolderTree } from '@/folders/types/folder-tree';

export const mutationSetLoading = 'setLoading';
export const mutationSetLoaded = 'setLoaded';
export const mutationSetTemplates = 'setTemplates';
export const mutationSetPagination = 'setPagination';
export const mutationSetFolders = 'setFolders';
export const mutationsSetBreadcrumbs = 'setBreadcrumbs';
export const mutationsSetFolderTree = 'setFolderTree';
export const mutationsSetFolderId = 'setFolderId';

export const mutations: MutationTree<ITemplateLibraryState> = {
  [mutationSetLoading](state: ITemplateLibraryState, loading: boolean) {
    state.loading = loading;
  },
  [mutationSetLoaded](state: ITemplateLibraryState, loaded: boolean) {
    state.loaded = loaded;
  },
  [mutationSetTemplates](
    state: ITemplateLibraryState,
    { templates, totalCount }: { templates: IDocument[]; totalCount: number }
  ) {
    state.templates = templates;
    state.totalCount = totalCount;
  },
  [mutationSetPagination](
    state: ITemplateLibraryState,
    {
      limit,
      offset,
      currentPageIndex,
      search,
    }: {
      limit: number;
      offset: number;
      currentPageIndex: number;
      search: string;
    }
  ) {
    state.pagination = { ...state.pagination, limit, offset, currentPageIndex, search };
  },
  [mutationSetFolders](state: ITemplateLibraryState, folders: IFolder[]) {
    state.folders = folders;
  },
  [mutationsSetBreadcrumbs](state: ITemplateLibraryState, breadcrumbs: IFolder[]) {
    state.breadcrumbs = breadcrumbs;
  },
  [mutationsSetFolderTree](state: ITemplateLibraryState, folderTree: IFolderTree) {
    state.folderTree = folderTree;
  },
  [mutationsSetFolderId](state: ITemplateLibraryState, folderId: string) {
    state.folderId = folderId;
  },
};
